/* W9 collection page, Phase 2 (2026-10-24). Markup, data and settings: sections/w9-collection.liquid.
   Liquid renders every card in the collection's order; this shows them a page at a time and runs the
   part-type chips, filters (with counts), sort and fit labels in the page. Nothing is re-rendered: the
   cards are moved and hidden. Filter state lives in the URL (w9_type, w9_fit, w9_price, w9_ti, w9_sort,
   w9_n; on the tires page also w9_rim, w9_pos, w9_brand) so Back and shared links land on the same view.
   The search results page (sections/w9-search-results) runs on this too, with cfg.search set.
   2026-10-25 (P12): a collection with 2+ part types shows every part at once under one heading per type,
   as the old grid did, and the rail's data-w9c-gnav links jump to the headings. Search keeps its chips.
   2026-11-01 (phone layout Phase 2): under 990px each group shows one row, then "Show all N <type>" opens
   it in place (24 at a time past 30, with Show fewer); a bike page's wheel builder band follows the second
   group, and the intro is two lines with More. Desktop is unchanged. */
(function () {
  'use strict';
  var KEY = 'w9_bike';
  var OTHER = '_other';
  var USED = 'used';
  var SORTS = ['best', 'low', 'high', 'new', 'az'];
  var PRICES = [
    { k: 'lo', label: 'Under $50', test: function (c) { return c < 5000; } },
    { k: 'mid', label: '$50 to $150', test: function (c) { return c >= 5000 && c <= 15000; } },
    { k: 'hi', label: 'Over $150', test: function (c) { return c > 15000; } }
  ];
  var desk = window.matchMedia('(min-width: 990px)');
  var GPAGE = 24;   // phones: an opened group past GALL parts shows this many more per tap
  var GALL = 30;    // phones: a group up to this size opens whole

  function $(s, el) { return (el || document).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function handleize(s) { return String(s || '').toLowerCase().replace(/['"’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function readBike() { try { var b = JSON.parse(localStorage.getItem(KEY) || 'null'); return b && b.label ? b : null; } catch (e) { return null; } }
  function safeUrl(u) { return typeof u === 'string' && /^\/(?!\/)/.test(u) ? u : ''; }
  function an(w) { return /^[aeiou]/i.test(String(w || '')) ? 'an ' : 'a '; }
  var CHECK = '<svg class="w9c__bar-ico" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

  /* ---- fit: the cart drawer's rule (sections/w9-cart-drawer, fitState), so a card, the drawer and the
     product page agree. ok | spec | uni | warn | unknown ---- */
  function bikeHandle(b) {
    var m = /\/collections\/([^\/?#]+)/.exec(b.url || '');
    return m ? decodeURIComponent(m[1]) : handleize((b.make || '') + ' ' + (b.model || ''));
  }
  function fitState(tags, type, b) {
    var h = bikeHandle(b);
    var model = (b.model || '').toLowerCase().trim();
    var make = (b.make || '').toLowerCase().trim();
    var labelHandle = handleize(b.label);
    if (type === 'custom wheel' || tags.indexOf('custom_product') > -1) return 'spec';
    var modelHit = tags.indexOf('model-' + h) > -1 || tags.indexOf(labelHandle) > -1 || (model && (tags.indexOf(model) > -1 || tags.indexOf(handleize(model)) > -1));
    if (!modelHit && model) modelHit = tags.some(function (t) { return t.length > 3 && t.indexOf('model-') !== 0 && model.indexOf(t + ' ') === 0; });
    if (modelHit) return 'ok';
    if (tags.indexOf('all make') > -1) return 'uni';
    var hasModelTags = tags.some(function (t) { return t.indexOf('model-') === 0; });
    var makeHit = make && (tags.indexOf(make) > -1 || tags.indexOf(handleize(make)) > -1);
    var emoto = tags.indexOf('emoto') > -1 || tags.indexOf('e-moto') > -1;
    if (hasModelTags || makeHit || emoto) return 'warn';
    return 'unknown';
  }

  /* ---- Sub-group rules, as the side nav reads them (assets/w9-collection-sidenav.js): "Heading=word|word";
     an exact product type wins, then any tag: rule, then the first heading whose word is in the title. ---- */
  function slug(s) { return String(s).toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'x'; }
  function norm(s) { return String(s == null ? '' : s).toLowerCase().replace(/\([^)]*\)/g, ' ').replace(/\*+[^*]+\*+/g, ' ').replace(/\s+/g, ' ').trim(); }
  function token(raw) {
    var v = String(raw).trim().toLowerCase(), kind = 'any';
    var m = /^(tag|type|title):\s*(.+)$/.exec(v);
    if (m) { kind = m[1]; v = m[2].trim(); }
    return v ? { kind: kind, v: v } : null;
  }
  function parseRules(spec) {
    spec = String(spec || '');
    var out = [];
    spec.split(spec.indexOf('\n') !== -1 ? /\r?\n/ : ',').forEach(function (e) {
      e = e.trim();
      if (!e) return;
      var label = e, list = [e];
      var i = e.indexOf('=');
      if (i > 0) { label = e.slice(0, i).trim(); list = e.slice(i + 1).split('|'); }
      var toks = list.map(token).filter(Boolean);
      if (label && toks.length) out.push({ label: label, slug: 'r-' + slug(label), toks: toks });
    });
    return out;
  }
  function matchRule(x, rules) {
    var t = norm(x.t), n = norm(x.n), i, j, k;
    if (t) {
      for (i = 0; i < rules.length; i++) for (j = 0; j < rules[i].toks.length; j++) {
        k = rules[i].toks[j];
        if ((k.kind === 'any' || k.kind === 'type') && k.v === t) return rules[i];
      }
    }
    for (i = 0; i < rules.length; i++) for (j = 0; j < rules[i].toks.length; j++) {
      k = rules[i].toks[j];
      if (k.kind === 'tag' && x.tags.indexOf(k.v) !== -1) return rules[i];
    }
    for (i = 0; i < rules.length; i++) for (j = 0; j < rules[i].toks.length; j++) {
      k = rules[i].toks[j];
      if (k.kind === 'tag' || k.kind === 'type') continue;
      if (n && n.indexOf(k.v) !== -1) return rules[i];
    }
    return null;
  }

  function init(root) {
    if (root.getAttribute('data-w9c-init')) return;
    root.setAttribute('data-w9c-init', '1');
    var cfg;
    try { cfg = JSON.parse($('[data-w9c-cfg]', root).textContent); } catch (e) { return; }
    var grid = $('[data-w9c-grid]', root);
    if (!grid) { root.classList.add('is-ready'); return; }
    var PAGE = cfg.pageSize || 24;
    var page = cfg.page || {};
    var band = cfg.band ? $('[data-w9c-band]', grid) : null;
    var chipsEl = $('[data-w9c-chips]', root);
    var gnavEl = $('[data-w9c-gnav]', root);
    var gnavWrap = $('[data-w9c-gnav-wrap]', root);
    var facetsEl = $('[data-w9c-facets]', root);
    var rail = $('[data-w9c-rail]', root);
    var scrim = $('[data-w9c-scrim]', root);
    var tools = $('[data-w9c-tools]', root);
    var bike = readBike();

    var items = $$('[data-w9c-item]', grid).map(function (li, i) {
      var name = $('.w9c__name', li);
      return {
        el: li, i: i, r: i,
        h: li.getAttribute('data-h'),
        g: li.getAttribute('data-g') || '',
        t: li.getAttribute('data-t') || '',
        n: name ? name.textContent.trim() : '',
        p: parseInt(li.getAttribute('data-p'), 10) || 0,
        d: parseInt(li.getAttribute('data-d'), 10) || 0,
        u: li.getAttribute('data-u') === '1',
        ti: li.getAttribute('data-ti') === '1',
        tags: (li.getAttribute('data-tags') || '').split('|').filter(Boolean),
        rp: (li.getAttribute('data-rp') || '').split('|').filter(Boolean).map(function (s) {
          var c = s.indexOf(':');
          return { r: s.slice(0, c), p: s.slice(c + 1) };
        }),
        brand: li.getAttribute('data-brand') || '',
        fit: $('[data-w9c-fit]', li),
        link: $('a', li),
        fs: null
      };
    });
    /* Tires page (Tire options block): rim / position / brand filters, and one sub-group (tubes and tire
       parts) in a row after the grid instead of under "All". */
    var tire = cfg.tire || null;
    var afterKey = tire && tire.after ? 'r-' + slug(tire.after) : '';
    var POS = [{ k: 'front', label: 'Front' }, { k: 'rear', label: 'Rear' }];
    function uniqSorted(fn, cmp) {
      var seen = {}, out = [];
      items.forEach(function (x) { fn(x).forEach(function (v) { if (!seen[v]) { seen[v] = 1; out.push(v); } }); });
      return out.sort(cmp);
    }
    var rimVals = tire ? uniqSorted(function (x) { return x.rp.map(function (c) { return c.r; }); }, function (a, b) { return parseFloat(b) - parseFloat(a); }) : [];
    /* Rim and position are checked on the same size: a tire that is 19" only at the rear isn't a 19" front. */
    function sizeOk(x, rims, poss) {
      if (!rims.length && !poss.length) return true;
      return x.rp.some(function (c) { return (!rims.length || rims.indexOf(c.r) > -1) && (!poss.length || poss.indexOf(c.p) > -1); });
    }
    var brandVals = tire ? uniqSorted(function (x) { return x.brand ? [x.brand] : []; }, function (a, b) {
      function n(v) { return items.filter(function (x) { return x.brand === v; }).length; }
      return n(b) - n(a) || a.localeCompare(b);
    }) : [];
    var bandItem = null;
    if (band) items.forEach(function (x) { if (x.h === band.getAttribute('data-h')) bandItem = x; });

    /* ---- part-type groups ---- */
    var labels = {};
    var fixedOrder = null;
    if (cfg.mode === 'rules') {
      var rules = parseRules(cfg.rules);
      var extra = {};
      items.forEach(function (x) {
        if (x.g === USED) return;
        var g = matchRule(x, rules);
        if (g) { x.g = g.slug; return; }
        if (cfg.auto && x.t) { var s = 'type-' + slug(x.t); extra[s] = x.t; x.g = s; return; }
        x.g = OTHER;
      });
      fixedOrder = rules.map(function (g) { labels[g.slug] = g.label; return g.slug; });
      Object.keys(extra).sort(function (a, b) { return extra[a].localeCompare(extra[b]); }).forEach(function (s) { labels[s] = extra[s]; fixedOrder.push(s); });
    } else {
      (cfg.groups || []).forEach(function (g) { labels[g.key] = g.label; });
      items.forEach(function (x) { if (!x.g || (x.g !== USED && !labels[x.g])) x.g = OTHER; });
    }
    labels[OTHER] = cfg.other || 'More parts';
    labels[USED] = cfg.usedLabel || 'Used & damaged';

    function base() { return items.slice().sort(function (a, b) { return a.r - b.r; }); }
    function groupKeys() {
      var have = {};
      items.forEach(function (x) { have[x.g] = (have[x.g] || 0) + 1; });
      var keys = [];
      if (fixedOrder) keys = fixedOrder.slice();
      else {
        /* On a bike page the chips follow the best sellers: a group sits where its top product does. */
        var seen = {};
        base().forEach(function (x) { if (!seen[x.g] && x.g !== OTHER && x.g !== USED) { seen[x.g] = 1; keys.push(x.g); } });
      }
      keys.push(OTHER, USED);
      return keys.filter(function (k) { return have[k]; });
    }

    /* ---- fit options, from the saved bike ---- */
    var fitOpts = [];
    var fitBy = {};
    function short(b) { return b ? (b.model || b.label) : ''; }
    function isThisBike(b) { return !!b && (b.url === page.url || handleize(b.label) === handleize(page.label)); }
    function setupFit() {
      fitOpts = [];
      fitBy = {};
      if (tire || cfg.nofit) { items.forEach(function (x) { x.fs = null; if (x.fit) x.fit.hidden = true; }); return; }
      items.forEach(function (x) { x.fs = bike ? fitState(x.tags, x.t.toLowerCase(), bike) : null; });
      if (bike) fitOpts.push({ k: 'mine', label: 'Fits your ' + short(bike), test: function (x) { return x.fs === 'ok' || x.fs === 'spec' || x.fs === 'uni'; } });
      else if (page.kind === 'model') fitOpts.push({ k: 'made', label: 'Made for the ' + page.short, test: function (x) { return !x.u; } });
      /* Search results that name a bike: the results are mixed, so "made for" is that bike's fit rule. */
      else if (cfg.search && page.url) fitOpts.push({ k: 'made', label: 'Made for the ' + page.short, test: function (x) { return fitState(x.tags, x.t.toLowerCase(), page) === 'ok'; } });
      fitOpts.push({ k: 'uni', label: 'Universal fit', test: function (x) { return x.u; } });
      fitBy = {};
      fitOpts.forEach(function (o) { fitBy[o.k] = o; });
      /* Card labels use the same words as the product page and cart drawer. */
      var s = short(bike);
      items.forEach(function (x) {
        if (!x.fit) return;
        var txt = '', cls = '';
        if (bike) {
          if (x.fs === 'ok') { txt = 'Fits your ' + s; cls = 'ok'; }
          else if (x.fs === 'spec') { txt = 'Built to your spec'; cls = 'uni'; }
          else if (x.fs === 'uni') { txt = 'Universal fit'; cls = 'uni'; }
          else if (x.fs === 'warn') { txt = 'Not listed for your ' + s; cls = 'warn'; }
        } else if (x.u) { txt = 'Universal fit'; cls = 'uni'; }
        x.fit.textContent = txt;
        x.fit.className = 'w9c__fit' + (cls ? ' w9c__fit--' + cls : '');
        x.fit.hidden = !txt;
      });
    }
    function fitCount(k) { var o = fitBy[k]; return o ? items.filter(o.test).length : 0; }

    /* ---- state ---- */
    var st = (function () {
      var q = new URLSearchParams(location.search);
      function list(k) { var v = q.get(k); return v ? v.split(',').filter(Boolean) : []; }
      var s = { types: list('w9_type'), fit: list('w9_fit'), price: list('w9_price'), ti: q.get('w9_ti') === '1', sort: q.get('w9_sort') || 'best', n: parseInt(q.get('w9_n'), 10) || PAGE, fitSet: q.has('w9_fit'),
        rim: list('w9_rim'), pos: list('w9_pos'), brand: list('w9_brand') };
      if (SORTS.indexOf(s.sort) < 0) s.sort = 'best';
      if (s.n < PAGE) s.n = PAGE;
      return s;
    })();
    function autoFit() {
      /* Off a bike's own page, a saved bike narrows the list to what fits it (Show all is one click).
         Not on search results: what was searched for stays listed, with fit labels. */
      st.fit = st.fit.filter(function (k) { return fitBy[k]; });
      if (!st.fitSet && bike && page.kind !== 'model' && !cfg.search) {
        var nf = fitCount('mine');
        if (nf > 0 && nf < items.length && st.fit.indexOf('mine') < 0) st.fit.push('mine');
      }
    }
    function priceKey(c) { for (var i = 0; i < PRICES.length; i++) if (PRICES[i].test(c)) return PRICES[i].k; return ''; }
    function match(x, skip) {
      return (skip === 'type' || (st.types.length ? st.types.indexOf(x.g) > -1 : !(afterKey && x.g === afterKey))) &&
        (skip === 'fit' || !st.fit.length || st.fit.some(function (k) { return fitBy[k] && fitBy[k].test(x); })) &&
        (skip === 'price' || !st.price.length || st.price.indexOf(priceKey(x.p)) > -1) &&
        (skip === 'ti' || !st.ti || x.ti) &&
        sizeOk(x, skip === 'rim' ? [] : st.rim, skip === 'pos' ? [] : st.pos) &&
        (skip === 'brand' || !st.brand.length || st.brand.indexOf(x.brand) > -1);
    }
    function count(skip, test) { var c = 0; items.forEach(function (x) { if (match(x, skip) && test(x)) c++; }); return c; }
    var sorters = {
      best: function (a, b) { return a.r - b.r; },
      low: function (a, b) { return a.p - b.p || a.r - b.r; },
      high: function (a, b) { return b.p - a.p || a.r - b.r; },
      new: function (a, b) { return b.d - a.d || a.r - b.r; },
      az: function (a, b) { return a.n.localeCompare(b.n); }
    };
    function bandOn() {
      return !!(band && st.sort === 'best' && !st.fit.length && !st.price.length && !st.ti &&
        (!st.types.length || (bandItem && st.types.indexOf(bandItem.g) > -1)));
    }
    function plural(n) {
      var w = cfg.noun;
      if (tire && !grouped && !(st.types.length && st.types.every(function (k) { return k === afterKey; }))) w = ['tire', 'tires'];
      return n + ' ' + (n === 1 ? w[0] : w[1]);
    }

    /* ---- chips (the promoted part-type filter) and the filter list ---- */
    var keys = [];
    var grouped = false;
    var heads = {};
    /* Grouped: one heading per part type in the grid, every part shown, the rail links to the headings.
       The tires page's after-row group becomes a heading of its own. */
    function buildGroups() {
      grouped = !cfg.search && keys.length >= 2;
      if (!grouped) return;
      afterKey = '';
      keys.forEach(function (k) {
        if (heads[k]) return;
        var li = document.createElement('li');
        li.className = 'w9c__gh';
        li.id = root.id + '-g-' + slug(k);
        li.tabIndex = -1;
        li.innerHTML = '<h2 class="w9c__gh-h">' + esc(labels[k]) + '</h2><span class="w9c__gh-n"></span>';
        heads[k] = li;
      });
      if (gnavEl) {
        gnavEl.innerHTML = keys.map(function (k) {
          return '<a href="#' + esc(heads[k].id) + '" data-w9c-jump="' + esc(k) + '"><span>' + esc(labels[k]) + '</span><span class="w9c__gnav-n"></span></a>';
        }).join('');
        gnavEl.hidden = false;
      }
      if (gnavWrap) gnavWrap.hidden = false;
    }
    /* Phones: the row after a group's first parts. A group of up to GALL parts opens whole ("Show all 15
       Controls"); a bigger one opens GPAGE at a time with a count. Show fewer closes it.
       A page with one real group (Used & damaged doesn't count, e.g. Hubs) lists that group like a plain
       page: GPAGE parts, then "Show all 34 parts" (2026-11-02, Sheldon). */
    var gOpen = {}, gMore = {}, gTotal = {}, gBase = {};
    function cols() {
      var c = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length;
      return c > 0 ? c : 2;
    }
    /* base: parts the group shows before Show all, from render(), which measures the row before it lifts the
       cards out. Reading the grid's columns while they are out forces a layout of a short page, and the browser
       pulls the scroll up to fit. single: the page's only real group. */
    function groupMore(k, total, n, base, single) {
      var li = gMore[k];
      gTotal[k] = total;
      gBase[k] = base;
      if (!base || total <= base) { if (li) li.hidden = true; return li || null; }
      if (!li) {
        li = document.createElement('li');
        li.className = 'w9c__gmore';
        gMore[k] = li;
      }
      var name = esc(labels[k]), html = '';
      if (gOpen[k] && n < total) html += '<span class="w9c__gmore-n">' + n + ' of ' + total + '</span>';
      if (n < total) {
        html += '<button type="button" class="w9c__btn w9c__btn--line" data-w9c-gmore="' + esc(k) + '">' +
          (gOpen[k] ? 'Show ' + Math.min(GPAGE, total - n) + ' more' :
            single ? (total - n <= GPAGE ? 'Show all ' + esc(plural(total)) : 'Show ' + GPAGE + ' more of ' + esc(plural(total))) :
            total > GALL ? 'Show ' + GPAGE + ' more of ' + total + ' ' + name : 'Show all ' + total + ' ' + name) + '</button>';
      }
      if (gOpen[k]) html += '<button type="button" class="w9c__link" data-w9c-gless="' + esc(k) + '">Show fewer</button>';
      li.innerHTML = html;
      li.hidden = false;
      return li;
    }
    /* Scroll at once: the theme sets scroll-behavior: smooth on <html>, which would glide these corrections. */
    function jump(scroll) {
      var s = document.documentElement.style, was = s.scrollBehavior;
      s.scrollBehavior = 'auto';
      scroll();
      s.scrollBehavior = was;
    }
    /* Redraw without moving the screen: el (a group heading) stays where it is in the window. */
    function holdPlace(el, redraw) {
      var y0 = el ? el.getBoundingClientRect().top : null;
      redraw();
      if (y0 === null) return;
      var dy = el.getBoundingClientRect().top - y0;
      if (Math.abs(dy) > 1) jump(function () { window.scrollBy(0, dy); });
    }
    /* The parts listed under a group's heading, in page order. */
    function groupEls(k) {
      var out = [], e = heads[k] && heads[k].nextElementSibling;
      while (e && !e.classList.contains('w9c__gh')) { if (e.hasAttribute('data-w9c-item') && !e.hidden) out.push(e); e = e.nextElementSibling; }
      return out;
    }

    function buildChips() {
      keys = groupKeys();
      buildGroups();
      if (!chipsEl) return;
      if (keys.length < 2) { chipsEl.innerHTML = ''; chipsEl.hidden = true; return; }
      chipsEl.hidden = false;
      chipsEl.innerHTML = '<button type="button" class="w9c__chip" data-w9c-chip="">' + (tire ? 'All tires' : 'All parts') + ' <span class="w9c__chip-n"></span></button>' +
        keys.map(function (k, i) {
          return '<button type="button" class="w9c__chip' + (i >= 9 ? ' is-extra' : '') + '" data-w9c-chip="' + esc(k) + '">' + esc(labels[k]) + ' <span class="w9c__chip-n"></span></button>';
        }).join('');
    }
    function optHtml(f, v, label, type) {
      return '<label class="w9c__opt" data-w9c-opt><input type="' + (type || 'checkbox') + '" data-w9c-f="' + f + '" value="' + esc(v) + '"><span class="w9c__opt-l">' + esc(label) + '</span><span class="w9c__opt-n"></span></label>';
    }
    function buildFacets() {
      if (!facetsEl) return;
      var html = '';
      if (keys.length >= 2 && !grouped) {
        html += '<fieldset class="w9c__fs"><legend>Part type</legend>' + keys.map(function (k) { return optHtml('type', k, labels[k]); }).join('') + '</fieldset>';
      }
      var fo = fitOpts.filter(function (o) { var c = fitCount(o.k); return c > 0 && c < items.length; });
      if (fo.length) html += '<fieldset class="w9c__fs"><legend>Fit</legend>' + fo.map(function (o) { return optHtml('fit', o.k, o.label); }).join('') + '</fieldset>';
      var pb = PRICES.filter(function (p) { return items.some(function (x) { return p.test(x.p); }); });
      if (pb.length > 1) html += '<fieldset class="w9c__fs"><legend>Price</legend>' + pb.map(function (p) { return optHtml('price', p.k, p.label); }).join('') + '</fieldset>';
      if (tire) {
        if (rimVals.length > 1) html += '<fieldset class="w9c__fs"><legend>Rim size</legend>' + rimVals.map(function (r) { return optHtml('rim', r, r + '-inch'); }).join('') + '</fieldset>';
        html += '<fieldset class="w9c__fs"><legend>Position</legend>' + POS.map(function (p) { return optHtml('pos', p.k, p.label); }).join('') + '</fieldset>';
        if (brandVals.length > 1) html += '<fieldset class="w9c__fs"><legend>Brand</legend>' + brandVals.map(function (b) { return optHtml('brand', b, b); }).join('') + '</fieldset>';
      }
      var nti = items.filter(function (x) { return x.ti; }).length;
      if (!tire && nti > 0 && nti < items.length) html += '<fieldset class="w9c__fs"><legend>Material</legend>' + optHtml('ti', '1', 'Titanium') + '</fieldset>';
      facetsEl.innerHTML = html;
    }
    function buildRims() {
      var el = $('[data-w9c-rims]', root);
      if (!el) return;
      el.innerHTML = rimVals.map(function (r) {
        return '<button type="button" class="w9c__rim" data-w9c-rim="' + esc(r) + '" aria-pressed="false">' + esc(r) + '&Prime;<span class="w9c__rim-n"></span></button>';
      }).join('');
    }
    /* Exact size / By bike open the page's W9 tire finder section inside the size box. */
    function finderSection() {
      var f = document.querySelector('[data-w9tf]');
      return f ? (f.closest('.shopify-section') || f) : null;
    }
    function toggleFinder(tab) {
      var sec = finderSection(), slot = $('[data-w9c-finder-slot]', root);
      if (!sec || !slot) return;
      var isOpen = sec.classList.contains('is-w9c-open') && slot.getAttribute('data-tab') === tab;
      if (isOpen) {
        sec.classList.remove('is-w9c-open');
        slot.removeAttribute('data-tab');
      } else {
        if (sec.parentNode !== slot) slot.appendChild(sec);
        sec.classList.add('is-w9c-open');
        slot.setAttribute('data-tab', tab);
        var t = sec.querySelector('[data-w9tf-tab="' + tab + '"]');
        if (t) t.click();
      }
      $$('[data-w9c-finder]', root).forEach(function (b) {
        b.setAttribute('aria-expanded', slot.getAttribute('data-tab') === b.getAttribute('data-w9c-finder') ? 'true' : 'false');
      });
    }
    function renderAfter() {
      var box = $('[data-w9c-after]', root), list = $('[data-w9c-after-list]', root);
      if (!box || !list || !afterKey) return;
      var picks = base().filter(function (x) { return x.g === afterKey; }).slice(0, tire.afterN || 4);
      box.hidden = !!st.types.length || !picks.length;
      if (list.getAttribute('data-done')) return;
      list.setAttribute('data-done', '1');
      picks.forEach(function (x) {
        var li = x.el.cloneNode(true);
        li.removeAttribute('data-w9c-item');
        li.className = 'w9c__item';
        li.hidden = false;
        list.appendChild(li);
      });
    }

    function updateControls() {
      if (chipsEl && !chipsEl.hidden) {
        $$('[data-w9c-chip]', chipsEl).forEach(function (b) {
          var k = b.getAttribute('data-w9c-chip');
          var on = k ? st.types.indexOf(k) > -1 : !st.types.length;
          var c = k ? count('type', function (x) { return x.g === k; }) : count('type', function (x) { return !(afterKey && x.g === afterKey); });
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          $('.w9c__chip-n', b).textContent = c;
          b.hidden = !on && c === 0;
        });
      }
      if (gnavEl && grouped) {
        var inBand = bandOn() ? bandItem : null;
        $$('[data-w9c-jump]', gnavEl).forEach(function (a) {
          var k = a.getAttribute('data-w9c-jump');
          var c = count('', function (x) { return x.g === k && x !== inBand; });
          $('.w9c__gnav-n', a).textContent = c;
          a.hidden = c === 0;
        });
      }
      $$('[data-w9c-f]', facetsEl).forEach(function (inp) {
        var f = inp.getAttribute('data-w9c-f'), v = inp.value, on, c;
        if (f === 'type') { on = st.types.indexOf(v) > -1; c = count('type', function (x) { return x.g === v; }); }
        else if (f === 'fit') { on = st.fit.indexOf(v) > -1; c = count('fit', fitBy[v].test); }
        else if (f === 'price') { on = st.price.indexOf(v) > -1; c = count('price', function (x) { return priceKey(x.p) === v; }); }
        else if (f === 'rim') { on = st.rim.indexOf(v) > -1; c = count('rim', function (x) { return sizeOk(x, [v], st.pos); }); }
        else if (f === 'pos') { on = st.pos.indexOf(v) > -1; c = count('pos', function (x) { return sizeOk(x, st.rim, [v]); }); }
        else if (f === 'brand') { on = st.brand.indexOf(v) > -1; c = count('brand', function (x) { return x.brand === v; }); }
        else { on = st.ti; c = count('ti', function (x) { return x.ti; }); }
        inp.checked = on;
        inp.disabled = !on && c === 0;
        var lab = inp.closest('[data-w9c-opt]');
        lab.classList.toggle('is-off', inp.disabled);
        $('.w9c__opt-n', lab).textContent = c;
      });
      $$('[data-w9c-rim]', root).forEach(function (b) {
        var r = b.getAttribute('data-w9c-rim');
        var on = st.rim.indexOf(r) > -1, c = count('rim', function (x) { return sizeOk(x, [r], st.pos); });
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.disabled = !on && c === 0;
        $('.w9c__rim-n', b).textContent = c;
      });
      $$('[data-w9c-seg]', root).forEach(function (b) {
        var k = b.getAttribute('data-w9c-seg');
        b.setAttribute('aria-pressed', (k ? st.pos.length === 1 && st.pos[0] === k : !st.pos.length) ? 'true' : 'false');
      });
      $$('[data-w9c-sortr]', root).forEach(function (r) { r.checked = r.value === st.sort; });
      var sel = $('[data-w9c-sort]', root);
      if (sel) sel.value = st.sort;
    }

    function applied() {
      var a = [];
      st.types.forEach(function (k) { a.push({ id: 'type:' + k, label: labels[k] || k }); });
      st.fit.forEach(function (k) { if (fitBy[k]) a.push({ id: 'fit:' + k, label: fitBy[k].label }); });
      st.price.forEach(function (k) { PRICES.forEach(function (p) { if (p.k === k) a.push({ id: 'price:' + k, label: p.label }); }); });
      if (st.ti) a.push({ id: 'ti:1', label: 'Titanium' });
      st.rim.forEach(function (r) { a.push({ id: 'rim:' + r, label: r + '-inch' }); });
      st.pos.forEach(function (k) { POS.forEach(function (p) { if (p.k === k) a.push({ id: 'pos:' + k, label: p.label }); }); });
      st.brand.forEach(function (b) { a.push({ id: 'brand:' + b, label: b }); });
      return a;
    }

    /* ---- the My bike bar ---- */
    function renderBar(listLen) {
      var el = $('[data-w9c-bar]', root);
      if (!el) return;
      var b = bike, cls = 'w9c__bar', html;
      /* Search results that name a bike or make: its band offers Save as my bike or the models, so the bar
         waits for a saved bike. */
      if (cfg.search && cfg.bikeBand) {
        $$('[data-w9sr-save]', root).forEach(function (s) { s.hidden = !!b && isThisBike(b); });
        $$('[data-w9sr-mine]', root).forEach(function (s) { s.hidden = !(b && isThisBike(b)); });
        el.hidden = !b;
        if (!b) return;
      }
      /* w9c__bar-long words drop on phones, where a one-button bar (w9c__bar--one) is a single line. */
      if (page.kind === 'model') {
        if (!b) {
          cls += ' w9c__bar--one';
          html = '<span class="w9c__bar-text"><strong>Riding ' + an(page.label) + esc(page.label) + '?</strong><span class="w9c__bar-long"> Save it as your bike and every part page shows what fits it.</span></span>' +
            '<button type="button" class="w9c__btn" data-w9c-save>Save <span class="w9c__bar-long">' + esc(page.short) + ' </span>as my bike</button>';
        } else if (isThisBike(b)) {
          cls += ' w9c__bar--ok w9c__bar--one';
          html = CHECK + '<span class="w9c__bar-text"><strong>Your bike: ' + esc(b.label) + '.</strong><span class="w9c__bar-long"> Every part here is listed for it.</span></span>' +
            '<button type="button" class="w9c__btn w9c__btn--line" data-w9h-bike-toggle>Change bike</button>';
        } else {
          cls += ' w9c__bar--warn';
          var bu = safeUrl(b.url);
          html = '<span class="w9c__bar-text"><strong>Your bike is ' + an(b.label) + esc(b.label) + '.</strong> This page is ' + esc(page.label) + ' parts. Cards marked “Fits your ' + esc(short(b)) + '” fit both.</span>' +
            (bu ? '<a class="w9c__btn" href="' + esc(bu) + '">Show ' + esc(short(b)) + ' parts</a>' : '') +
            '<button type="button" class="w9c__btn w9c__btn--line" data-w9c-save>My bike is ' + an(page.short) + esc(page.short) + '</button>';
        }
      } else if (!b) {
        cls += ' w9c__bar--one';
        html = '<span class="w9c__bar-text">Pick your bike to see which of these fit it.</span><button type="button" class="w9c__btn" data-w9h-bike-toggle>Pick your bike</button>';
      } else {
        var nf = fitCount('mine');
        var change = '<button type="button" class="w9c__link" data-w9h-bike-toggle>Change bike</button>';
        if (!nf) {
          cls += ' w9c__bar--warn';
          html = '<span class="w9c__bar-text">None of these are listed for your ' + esc(b.label) + ' yet. <a href="#' + esc(helpId) + '">Ask us</a> if you’re not sure.</span>' + change;
        } else if (st.fit.indexOf('mine') > -1) {
          cls += ' w9c__bar--ok';
          html = CHECK + '<span class="w9c__bar-text"><strong>Showing ' + (nf === items.length ? 'all ' : 'the ') + plural(nf) + ' that fit your ' + esc(b.label) + '.</strong></span>' +
            (nf < items.length ? '<button type="button" class="w9c__btn w9c__btn--line" data-w9c-fitall>Show all ' + items.length + '</button>' : '') + change;
        } else {
          html = '<span class="w9c__bar-text">' + nf + ' of these fit your ' + esc(b.label) + '.</span><button type="button" class="w9c__btn" data-w9c-fitmine>Show only what fits</button>' + change;
        }
      }
      el.className = cls;
      el.innerHTML = html;
    }
    var helpEl = $('.w9c__help', root);
    var helpId = helpEl ? helpEl.id : '';

    /* ---- draw ---- */
    function writeUrl() {
      try {
        var u = new URL(location.href);
        var q = u.searchParams;
        function put(k, v) { if (v) q.set(k, v); else q.delete(k); }
        put('w9_type', st.types.join(','));
        put('w9_price', st.price.join(','));
        put('w9_ti', st.ti ? '1' : '');
        put('w9_rim', st.rim.join(','));
        put('w9_pos', st.pos.join(','));
        put('w9_brand', st.brand.join(','));
        put('w9_sort', st.sort === 'best' ? '' : st.sort);
        put('w9_n', st.n > PAGE ? String(st.n) : '');
        if (st.fitSet) q.set('w9_fit', st.fit.length ? st.fit.join(',') : 'all'); else q.delete('w9_fit');
        history.replaceState(history.state, '', u.pathname + (q.toString() ? '?' + q.toString() : '') + u.hash);
      } catch (e) {}
    }

    function render(focusFrom) {
      var showBand = bandOn();
      var list = items.filter(function (x) { return match(x) && !(showBand && x === bandItem); }).sort(sorters[st.sort]);
      var total = list.length + (showBand ? 1 : 0);
      var vis = grouped ? list : list.slice(0, st.n);
      items.forEach(function (x) { x.v = false; });
      vis.forEach(function (x) { x.v = true; });
      var frag = document.createDocumentFragment();
      /* Phones, grouped: the band waits until after the second group, so parts come first. */
      var row = grouped && !desk.matches ? cols() : 0;
      var bandLate = !!(band && row);
      if (band) { band.hidden = !showBand; if (!bandLate) frag.appendChild(band); }
      if (grouped) {
        /* Heading, then that type's parts in the chosen sort; an empty type's heading is parked hidden.
           Phones: one row, then the group's Show all row (opened groups keep their count in gOpen). */
        var filled = 0;
        var single = !!row && keys.filter(function (k) { return k !== USED && vis.some(function (x) { return x.g === k; }); }).length === 1;
        keys.forEach(function (k) {
          var g = vis.filter(function (x) { return x.g === k; });
          var head = heads[k];
          head.hidden = !g.length;
          $('.w9c__gh-n', head).textContent = g.length;
          frag.appendChild(head);
          var one = single && k !== USED;
          var base = one ? GPAGE : row;
          var n = !base || g.length <= base ? g.length : Math.min(g.length, gOpen[k] || base);
          g.forEach(function (x, i) {
            if (i < n) { x.el.hidden = false; frag.appendChild(x.el); } else x.v = false;
          });
          var more = groupMore(k, g.length, n, base, one);
          if (more) frag.appendChild(more);
          if (g.length && ++filled === 2 && bandLate) frag.appendChild(band);
        });
        if (bandLate && filled < 2) frag.appendChild(band);
      } else {
        vis.forEach(function (x) { x.el.hidden = false; frag.appendChild(x.el); });
      }
      items.forEach(function (x) { if (!x.v) { x.el.hidden = true; frag.appendChild(x.el); } });
      grid.appendChild(frag);

      var totalEl = $('[data-w9c-total]', root);
      if (totalEl) totalEl.textContent = plural(total);
      var shownEl = $('[data-w9c-shown]', root);
      if (shownEl) shownEl.textContent = total && !grouped ? 'Showing ' + (vis.length + (showBand ? 1 : 0)) + ' of ' + plural(total) : '';
      var more = $('[data-w9c-more]', root);
      if (more) more.hidden = vis.length >= list.length;
      var empty = $('[data-w9c-empty]', root);
      if (empty) empty.hidden = total > 0;
      $$('[data-w9c-showbtn]', root).forEach(function (b) { b.textContent = 'Show ' + plural(total); });

      var a = applied();
      var ap = $('[data-w9c-applied]', root);
      if (ap) {
        ap.hidden = !a.length;
        ap.innerHTML = a.map(function (f) {
          return '<button type="button" class="w9c__tag" data-w9c-rm="' + esc(f.id) + '" aria-label="Remove filter: ' + esc(f.label) + '">' + esc(f.label) +
            '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>';
        }).join('') + (a.length ? '<button type="button" class="w9c__link" data-w9c-clear>Clear all</button>' : '');
      }
      var badge = $('[data-w9c-badge]', root);
      if (badge) { badge.hidden = !a.length; badge.textContent = a.length; }

      updateControls();
      renderBar(total);
      renderAfter();
      writeUrl();
      if (typeof focusFrom === 'number' && list[focusFrom] && list[focusFrom].link) list[focusFrom].link.focus({ preventScroll: false });
    }

    /* Bring the results into view after a filter change, if the list top has scrolled away. */
    function toResults() {
      if (!tools || (rail && rail.classList.contains('is-open'))) return;
      var r = tools.getBoundingClientRect();
      if (r.top < 0) window.scrollTo({ top: window.pageYOffset + r.top - 12, behavior: 'smooth' });
    }
    function change(fn) { fn(); st.n = PAGE; gOpen = {}; render(); toResults(); }
    function flip(arr, v) { var i = arr.indexOf(v); if (i > -1) arr.splice(i, 1); else arr.push(v); }

    /* ---- the phone tray ---- */
    var opener = null;
    function onKey(e) { if (e.key === 'Escape') closeTray(); }
    function openTray(btn) {
      if (!rail || desk.matches) return;
      opener = btn || null;
      /* Shopify's preview strip sits over the bottom of the screen; keep Show N parts above it. */
      var pb = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
      rail.style.bottom = pb && pb.offsetHeight ? pb.offsetHeight + 'px' : '';
      rail.setAttribute('role', 'dialog');
      rail.setAttribute('aria-modal', 'true');
      rail.classList.add('is-open');
      if (scrim) scrim.hidden = false;
      document.documentElement.classList.add('w9c-lock');
      document.addEventListener('keydown', onKey);
      var c = $('[data-w9c-close]', rail);
      if (c) c.focus();
    }
    function closeTray(stay) {
      if (!rail || !rail.classList.contains('is-open')) return;
      rail.classList.remove('is-open');
      rail.removeAttribute('role');
      rail.removeAttribute('aria-modal');
      if (scrim) scrim.hidden = true;
      document.documentElement.classList.remove('w9c-lock');
      document.removeEventListener('keydown', onKey);
      /* stay: a heading link takes the focus and the scroll itself (focusing the button cancels it). */
      if (stay === true) return;
      if (opener && document.contains(opener)) opener.focus();
      toResults();
    }
    if (desk.addEventListener) desk.addEventListener('change', closeTray); else if (desk.addListener) desk.addListener(closeTray);
    /* Crossing 990px or the 2/3-column line changes how many parts a group shows on phones. */
    [desk, window.matchMedia('(min-width: 750px)')].forEach(function (m) {
      function redraw() { render(); }
      if (m.addEventListener) m.addEventListener('change', redraw); else if (m.addListener) m.addListener(redraw);
    });

    function saveBike() {
      var b = { label: page.label, url: page.url, make: page.make, model: page.model };
      try { localStorage.setItem(KEY, JSON.stringify(b)); } catch (e) {}
      /* The header redraws on a storage event for w9_bike (it only fires across tabs by itself). */
      try { window.dispatchEvent(new StorageEvent('storage', { key: KEY })); } catch (e2) {}
    }
    function bikeChanged() {
      bike = readBike();
      setupFit();
      st.fitSet = false;
      st.fit = [];
      autoFit();
      buildFacets();
      render();
    }
    window.addEventListener('storage', function (e) { if (e.key === KEY) bikeChanged(); });

    root.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null;
      if (!t) return;
      var el;
      if ((el = t.closest('[data-w9c-chip]'))) {
        var k = el.getAttribute('data-w9c-chip');
        change(function () { if (!k) st.types = []; else flip(st.types, k); });
      } else if ((el = t.closest('[data-w9c-jump]'))) {
        var head = heads[el.getAttribute('data-w9c-jump')];
        if (!head) return;
        e.preventDefault();
        closeTray(true);
        requestAnimationFrame(function () {
          head.scrollIntoView({ behavior: 'smooth', block: 'start' });
          head.focus({ preventScroll: true });
        });
      } else if ((el = t.closest('[data-w9c-rm]'))) {
        var id = el.getAttribute('data-w9c-rm'), i0 = id.indexOf(':');
        var parts = [id.slice(0, i0), id.slice(i0 + 1)];
        change(function () {
          if (parts[0] === 'type') flip(st.types, parts[1]);
          else if (parts[0] === 'fit') { flip(st.fit, parts[1]); st.fitSet = true; }
          else if (parts[0] === 'price') flip(st.price, parts[1]);
          else if (parts[0] === 'rim') flip(st.rim, parts[1]);
          else if (parts[0] === 'pos') flip(st.pos, parts[1]);
          else if (parts[0] === 'brand') flip(st.brand, parts[1]);
          else st.ti = false;
        });
      } else if ((el = t.closest('[data-w9c-rim]'))) {
        var r = el.getAttribute('data-w9c-rim');
        change(function () { flip(st.rim, r); });
      } else if ((el = t.closest('[data-w9c-seg]'))) {
        var sk = el.getAttribute('data-w9c-seg');
        change(function () { st.pos = sk ? [sk] : []; });
      } else if ((el = t.closest('[data-w9c-finder]'))) {
        toggleFinder(el.getAttribute('data-w9c-finder'));
      } else if (t.closest('[data-w9c-clear]')) {
        change(function () { st.types = []; st.fit = []; st.price = []; st.ti = false; st.fitSet = true; st.rim = []; st.pos = []; st.brand = []; });
      } else if (t.closest('[data-w9c-more]')) {
        var from = st.n;
        st.n += PAGE;
        render(from);
      } else if ((el = t.closest('[data-w9c-gmore]'))) {
        /* Open a group (or show more of it) where it is: the screen stays put and the new parts appear
           under the ones already showing. Then the focus goes to the first new part. */
        var gk = el.getAttribute('data-w9c-gmore');
        var before = gOpen[gk] || gBase[gk] || cols();
        gOpen[gk] = (gTotal[gk] || 0) <= GALL ? gTotal[gk] : before + GPAGE;
        holdPlace(heads[gk], render);
        var shownEls = groupEls(gk);
        var nl = shownEls[before] && $('a', shownEls[before]);
        if (nl) nl.focus({ preventScroll: true });
      } else if ((el = t.closest('[data-w9c-gless]'))) {
        /* Close it again and come back to its heading if that has scrolled away (or under the pinned header
           and Filter bar: the 84px of .w9c__gh's scroll-margin-top). */
        var lk = el.getAttribute('data-w9c-gless');
        delete gOpen[lk];
        var lh = heads[lk];
        holdPlace(lh, render);
        if (lh) {
          var under = (parseFloat(getComputedStyle(root).getPropertyValue('--w9c-top')) || 0) + 84;
          if (lh.getBoundingClientRect().top < under) jump(function () { lh.scrollIntoView({ block: 'start' }); });
          lh.focus({ preventScroll: true });
        }
      } else if ((el = t.closest('[data-w9c-open]'))) {
        openTray(el);
      } else if (t.closest('[data-w9c-close]') || t === scrim) {
        closeTray();
      } else if (t.closest('[data-w9c-save]')) {
        saveBike();
      } else if (t.closest('[data-w9c-fitall]')) {
        change(function () { var i = st.fit.indexOf('mine'); if (i > -1) st.fit.splice(i, 1); st.fitSet = true; });
      } else if (t.closest('[data-w9c-fitmine]')) {
        change(function () { if (st.fit.indexOf('mine') < 0) st.fit.push('mine'); st.fitSet = true; });
      }
    });
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-w9c-sort]') || t.matches('[data-w9c-sortr]')) {
        if (SORTS.indexOf(t.value) > -1) change(function () { st.sort = t.value; });
        return;
      }
      var f = t.getAttribute('data-w9c-f');
      if (!f) return;
      change(function () {
        if (f === 'type') flip(st.types, t.value);
        else if (f === 'fit') { flip(st.fit, t.value); st.fitSet = true; }
        else if (f === 'price') flip(st.price, t.value);
        else if (f === 'rim') flip(st.rim, t.value);
        else if (f === 'pos') flip(st.pos, t.value);
        else if (f === 'brand') flip(st.brand, t.value);
        else st.ti = !st.ti;
      });
    });

    /* Keep the phone toolbar under a sticky header, if the header sticks. */
    function stickTop() {
      var top = 0;
      $$('[data-w9h], .shopify-section-group-header-group').forEach(function (h) {
        var cs = getComputedStyle(h);
        if (cs.position === 'sticky' || cs.position === 'fixed') top = Math.max(top, Math.round(h.getBoundingClientRect().bottom));
      });
      root.style.setProperty('--w9c-top', Math.max(0, top) + 'px');
    }

    setupFit();
    autoFit();
    buildChips();
    buildFacets();
    if (tire) {
      buildRims();
      if (!finderSection()) $$('[data-w9c-finder]', root).forEach(function (b) { b.hidden = true; });
    }
    render();
    stickTop();
    window.addEventListener('resize', stickTop);
    root.classList.add('is-ready');

    /* Phones: the intro is clamped to two lines (w9-collection.css); its More button stays only when the
       text runs longer than that. */
    var intro = $('.w9c__intro', root), introMore = $('[data-w9c-intro]', root);
    if (intro && introMore) {
      var fitsAll = function () {
        introMore.hidden = desk.matches || (!intro.classList.contains('is-open') && intro.scrollHeight <= intro.clientHeight + 1);
      };
      introMore.addEventListener('click', function () {
        var on = intro.classList.toggle('is-open');
        introMore.setAttribute('aria-expanded', on ? 'true' : 'false');
        introMore.textContent = on ? 'Less' : 'More';
      });
      fitsAll();
      window.addEventListener('resize', fitsAll);
    }

    /* The collection isn't set to Best selling in admin: ask Shopify for that order once, then re-rank. */
    if (cfg.rerank && window.fetch) {
      grid.setAttribute('aria-busy', 'true');
      fetch(cfg.rerank, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var re = /data-w9c-item data-h="([^"]+)"/g, m, rank = {}, i = 0;
          while ((m = re.exec(html))) if (!(m[1] in rank)) rank[m[1]] = i++;
          if (!i) return;
          items.forEach(function (x) { x.r = x.h in rank ? rank[x.h] : 100000 + x.i; });
          buildChips();
          buildFacets();
          render();
        })
        .catch(function () {})
        .then(function () { grid.removeAttribute('aria-busy'); });
    }
  }

  function boot() { $$('[data-w9c]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
